import * as classNames from 'classnames';
import * as React from 'react';
import { Box } from 'signoxe/components/layout';
import { Icon } from 'signoxe/components/widgets';
import { ITag } from 'signoxe/types';
import './styles.scss';

const isStrArray = (tags): tags is string[] => {
  return typeof tags[0] === 'string';
};

const ensureITag = (tags: ITag[] | string[]): ITag[] => {
  if (tags && tags.length > 0) {
    if (isStrArray(tags)) {
      return tags.map((tag) => ({name: tag, count: 1, selected: false}));
    } else return tags;
  } else return [];
};

const TagList: React.SFC<ITagListProps> = ({tags, onTagAdd, onTagRemove, onTagClick}) => (
  <Box className="tags-list"
       direction="row"
       alignItems="center"
       alignContent="flex-start"
       justifyContent="flex-start" wrap>
    {ensureITag(tags).map((tag: ITag) => (
      <span className={classNames('label', {success: tag.selected})}
            key={`asset-tag-${tag.name}`}
            onClick={() => onTagClick && onTagClick(tag.name)}>
          {tag.name}
        {onTagRemove && ' | '}
        {onTagRemove &&
        <Icon title="Delete tag"
              name="times"
              margin={0}
              color="white"
              size="0.75rem"
              onClick={() => onTagRemove(tag.name)}/>}
        </span>
    ))}
    {onTagAdd &&
    <input type="text"
           placeholder="Add Tag"
           title="Add tag [press Enter or add a comma submit]"
           onKeyUp={(event) => {
             // If the presses Enter (keyCode 13) or enters a comma (keyCode 188)
             if (event.keyCode === 13 || event.keyCode === 188) {
               const target = event.target as HTMLInputElement;
               onTagAdd(target.value.trim().replace(',', ''));
               target.value = '';
             }
           }}/>}
  </Box>
);

interface ITagListProps {
  tags: ITag[] | string[];
  onTagAdd?: (tag: string) => void;
  onTagRemove?: (tag: string) => void;
  onTagClick?: (tag: string) => void;
}

export default TagList;



// WEBPACK FOOTER //
// ./src/components/widgets/TagList/index.tsx